export default function IconHomeworking() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-7097eef1-859c-407e-9fe5-df786cfbddd6"
      data-name="Layer 2"
      viewBox="0 0 60 60"
    >
      <defs>
        <style>
          {
            ".uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9{fill:var(--color-primary(-alpha(-light)));stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-77eedbbf-d085-4b01-b0ae-633e9a000e0f" data-name="Layer 1">
        <path
          d="M28.242 0h3.516v60h-3.516z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
        <path
          d="M31.758 51.68H21.21V31.172h10.547V51.68Zm-7.031-3.516h3.515V34.687h-3.515v13.477Z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
        <path
          d="M31.758 51.68H3.633V22.617h28.125V51.68Zm-24.61-3.516h21.094V26.133H7.148v22.031Z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
        <path
          d="M30 26.133H0v-2.99L28.948 1.52l2.104 2.817-24.474 18.28H30v3.515z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
        <path
          d="M60 51.68H28.242V13.36H60v38.32Zm-28.242-3.516h24.726V16.875H31.758v31.29Z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
        <path
          d="M50.964 31.172h-13.23v-3.516h13.23a5.527 5.527 0 0 0 5.52-5.52v-5.261H30v-3.516h30v8.776c0 4.983-4.054 9.037-9.036 9.037Z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
        <path
          d="M38.79 39.14H28.241V25.43H38.79v13.71Zm-7.032-3.515h3.516v-6.68h-3.516v6.68ZM43.594 16.875H28.242V5.039h8.63a6.729 6.729 0 0 1 6.722 6.721v5.115Zm-11.836-3.516h8.32V11.76a3.21 3.21 0 0 0-3.205-3.205h-5.115v4.804ZM12.422 31.348h3.516v7.617h-3.516z"
          className="uuid-fa9f3db1-d069-4dd0-ba64-2a1a018fe4a9"
        />
      </g>
    </svg>
  );
}
